export const dateFormatBootPay = function (date: Date) {
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const monthString = String(month >= 10 ? month : '0' + month);
  const dayString = String(day >= 10 ? day : '0' + day);

  return date.getFullYear() + '-' + monthString + '-' + dayString;
};
